// Dashboard Users rankings page translations (pt-BR), loaded into dashboard.users.rankings by ../pt-BR.users.js
module.exports = {
  menu: "Rankings",
  title: "Rankings",
  description: "Top utilizadores por critério e quem mais evoluiu no período.",
  criteria: {
    created: "Eventos criados",
    shared: "Eventos partilhados",
    followers: "Seguidores",
    invites: "Convites enviados",
    checkins: "Check-ins",
    engagement: "Engajamento",
    time: "Tempo de uso",
  },
  columns: {
    rank: "#",
    user: "Utilizador",
    city: "Cidade",
    period: "No período",
    minutes: "Minutos",
  },
  user: "ID {id}",
  username: "@{username}",
  growth: "+{value}%",
  panels: {
    top: "Top utilizadores — {criterion}",
    topNote: "Visível só para administradores. Só o @ e a cidade do perfil, sem outros dados pessoais.",
    risers: "Quem mais cresceu",
  },
  panelInfo: {
    top: "Utilizadores com o maior total no critério escolhido, no período.\nFonte: Firebase (eventos, partilhas, seguidores, convites, “Eu vou”, visualizações e registo de atividade).",
    risers: "Utilizadores cujo total mais cresceu face ao período anterior.\nFonte: Firebase (as mesmas contagens do top).",
  },
};
